import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OperadorService } from '../services/operador.service';

@Component({
  selector: 'app-access-manager',
  templateUrl: './access-manager.component.html',
  styleUrls: ['./access-manager.component.scss'],
})
export class AccessManagerComponent implements OnInit {
  constructor(
    private _operadorService: OperadorService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._route.queryParams.subscribe((data) => {
      if (data['id'] !== undefined && data['token'] !== undefined) {
        //
        this._operadorService.loginAdmin(data['id'], data['token']).subscribe(
          (data) => {
            if (data['access_token']) {
              this._operadorService.setOperadorLoggedIn(data, true);

              this._operadorService.profile().subscribe((data) => {
                this._router.navigate(['app']);
              });
            } else {
              this._router.navigate(['/acessar']);
            }
          },
          (error) => {
            this._router.navigate(['/acessar']);
          }
        );
      } else {
        this._router.navigate(['/acessar']);
      }
    });
  }
}
